<template>
  <div class="home-map">
 <UiHeading
      :h="'2'"
      :type="'D'"
      :text="'店舗情報'"
      :subTitle="'information'"
    />
    <UiMap
    :type="`A`"
    :imgpath="'yui-map.jpg'" :imgName="'yui-imge'" :name="`低糖質専門店 結`" :address="`岐阜県岐阜市玉宮町1-20 M.clues1F`" :tel="`058-213-1289`" :open="`11:30-21:00（金・土・祝前日～23:30）`" :close="`月・火`"
    />
          <div class="space-50">
      <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3251.6669265419687!2d136.75574256554583!3d35.413505602214954!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6003a90e2d7982b5%3A0xd1022c35936260b0!2zQ2FmZWJhciZQYXJ0eWxvdW5nZSDntZAg44CceXVp44Cc!5e0!3m2!1sja!2sjp!4v1647578393298!5m2!1sja!2sjp" width="100%" height="450" style="border:0;margin-bottom:50px;" allowfullscreen="" loading="lazy"></iframe>
</div>

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import UiMap from '../Ui/Map.vue';
import UiHeading from '../Ui/Heading.vue';

export default {
  name: "HomeMap",
  components: {   
     UiMap,
     UiHeading
     },
  props: {
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["rootUrl"]),
  },
};
</script>

<style lang="scss" scoped>

h1,h2 {
  font-size: 32px;
}
h3{
  font-size: 22px;
}


.typeA {
color: var(--green);

  h1,
  h2,
  h3,
  h4,
  h5 {
    text-align: center;
  }
}
.typeB,.typeB2 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100px;
  h1,
  h2,
  h3,
  h4,
  h5 {
    color: white;
  }
}
.typeB{
  background-color: var(--green);
}.typeB2{
  background-color: var(--blue);
}
.typeC {
  h1,
  h2,
  h3,
  h4,
  h5 {
    text-align: left;
    border-bottom: var(--green) solid 1px;
    padding-bottom: 10px;
    font-weight: 500;
  }
}

</style>
